import {isBrowserContext} from 'core/helpers';
import {GTM_API_KEY} from 'core/helpers/env';
import {GTM_SRC_URL} from 'modules/google-analytics/constants';

export class GoogleAnalyticsService {
    public static GA_SCRIPT_TAG_ID = 'ga-script';
    public static GTM_SCRIPT_TAG_ID = 'gtm-script';

    private static connectScript = (config: {id: string; src: string; onLoad: () => void}): Promise<boolean> => {
        return new Promise((resolve) => {
            if (!isBrowserContext()) {
                return;
            }

            if (document.querySelector(`#${config.id}`)) {
                resolve(true);
                return;
            }

            const tag = document.createElement('script');

            tag.id = config.id;
            tag.defer = true;
            // eslint-disable-next-line no-undef
            tag.src = config.src;

            tag.addEventListener('load', () => {
                config.onLoad();
                resolve(true);
            });

            tag.addEventListener('error', () => resolve(false));

            document.head.append(tag);
        });
    };

    public static gtmConnectScript = async () => {
        return GoogleAnalyticsService.connectScript({
            id: GoogleAnalyticsService.GTM_SCRIPT_TAG_ID,
            onLoad: () => {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                GoogleAnalyticsService.gtag({event: 'gtm.js', 'gtm.start': new Date().getTime()});
            },
            src: `${GTM_SRC_URL}?id=${GTM_API_KEY}`,
        });
    };

    public static gtag(...args: any[]) {
        if (!global.dataLayer) {
            global.dataLayer = [];
        }

        if (global?.dataLayer?.push) {
            global.dataLayer?.push(...args);
        }
    }
}
